import { BaseTypeModel } from '../base-type.model';
import { WhatsAppTemplateParamModel } from '../whatsapp/whatsapp-template-param.model';
import { ReminderConfigModel } from './reminder-config.model';

export interface TransactionalEmailTypeModel extends BaseTypeModel {
  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailTo: string;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;
  emailAttachmentFileName: string;

  autoPurge: boolean;
  autoPurgeByDays: number;

  sendSms: boolean;
  smsContent: string;

  passwordProtected: boolean;
  hasAttachment: boolean;

  archive: boolean;

  emailTotal: number;
  emailStatusBounced: number;
  emailStatusBouncedSkip: number;
  emailStatusOpened: number;
  emailStatusSent: number;
  emailStatusUnsubscribed: number;
  emailStatusUnsubscribedSkip: number;
  emailStatusAcknowledge: number;

  whatsAppTemplateName: string;
  htmlTemplateName?: string;
  multipleAttachments?: boolean;
  txtSeparator?: string;
  hasHtmlFile?: boolean;
  hasReminder?: boolean;
  hasAcknowledgement?: boolean;
  acknowledgementExpiryDays?: number | null;
  hasCustomAcknowledgeUrl?: boolean;
  customAcknowledgeUrl?: string | null;
  customAcknowledgeUrlSecret?: string | null;
  hasCustomExpiryUrl?: boolean;
  customExpiryUrl?: string | null;
  hasCustomLandingPage?: boolean;
  customSuccessLandingUrl?: string | null;
  customFailLandingUrl?: string | null;
  whatsAppTemplateParams: WhatsAppTemplateParamModel[];
  reminderConfigs?: ReminderConfigModel[];
  isTest?: boolean;
  test?: boolean;
}
